// extracted by mini-css-extract-plugin
export var navLinks = "nav-module--nav-links--2xgmM";
export var navLinkText = "nav-module--navLinkText--2ErWV";
export var activeNavLink = "nav-module--activeNavLink--1s_JW";
export var navLinkItem = "nav-module--nav-link-item--1v8XK";